import { SerializedStyles, css } from "@emotion/react";
import React from "react";
import { mediaQueries } from "@upsun/react-component-library/src/styles/css-utils";
import InvertImage from "../InvertImage";

type StacksProps = {
  css?: SerializedStyles;
};

const Stacks: React.FC<StacksProps> = ({ ...props }) => {
  const list = [
    { name: "Django", image: "/homepage/stacks/django.svg", invert: true },
    { name: "Langchain", image: "/homepage/stacks/langchain.svg" },
    { name: "Gin", image: "/homepage/stacks/gin.svg" },
    { name: "Symfony", image: "/homepage/stacks/symfony.svg", invert: true },
    { name: "Laravel", image: "/homepage/stacks/laravel.svg" },
    { name: "Next.js", image: "/homepage/stacks/next.svg", invert: true },
    { name: "Rails", image: "/homepage/stacks/rails.svg" },
    { name: "Express", image: "/homepage/stacks/express.svg", invert: true },
    { name: "Flask", image: "/homepage/stacks/flask.svg", invert: true },
    { name: "Phoenix", image: "/homepage/stacks/phoenix.svg" },
    { name: "Actix Web", image: "/homepage/stacks/actix.svg", invert: true },
    { name: "Torchserve", image: "/homepage/stacks/torchserve.svg" },
    { name: "Koa", image: "/homepage/stacks/koa.svg", invert: true },
  ];

  const containerStyles = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    margin: 0 auto;
    max-width: 1050px;

    ${mediaQueries.md} {
      gap: 64px;
    }
  `;

  const itemStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 0 0 calc(33% - 24px);

    p {
      margin-bottom: 0 !important;
    }

    ${mediaQueries.md} {
      flex: 0 0 calc(20% - 64px);
    }

    ${mediaQueries.lg} {
      flex: 0 0 calc(14.2857% - 64px);
    }
  `;

  const imgContainerStyles = css`
    display: flex;
    padding: 16px;
    border-radius: 80px;
    border: 1px solid #ffffff30;
    box-shadow: 0px 7.079px 7.079px 0px
      rgba(96, 70, 255, 0.3);

    img {
      width: 32px;
      height: 32px;
    }

    ${mediaQueries.md} {
      padding: 20px;
    }
  `;

  const nameStyles = css`
    font-family: "Space Grotesk";
    font-size: 16px;
    font-weight: 500;
    margin-top: 16px;
    white-space: nowrap;

    ${mediaQueries.md} {
      font-size: 18px;
    }
  `;

  return (
    <div css={containerStyles}>
      {list.map((item) => (
        <div css={itemStyles} key={item.image}>
          <div css={imgContainerStyles}>
            {item.invert ? <InvertImage src={item.image} /> : <img src={item.image} alt="" />}
          </div>
          <p css={nameStyles}>{item.name}</p>
        </div>
      ))}
    </div>
  );
};

export default Stacks;
